import { render, staticRenderFns } from "./chatDetail.vue?vue&type=template&id=82d08478&scoped=true&"
import script from "./chatDetail.vue?vue&type=script&lang=js&"
export * from "./chatDetail.vue?vue&type=script&lang=js&"
import style0 from "./chatDetail.vue?vue&type=style&index=0&id=82d08478&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d08478",
  null
  
)

export default component.exports